

export const about_heading = [
    {
        title: "Transforming Businesses  "
    },
    {
        title: "With Innovation"
    },
  ];